import MarketingLayout from "@/components/MarketingLayout";
import SEOPageNew from "@/pages/newsite/SEOPageNew";

export default function TikTokAdsSpyToolPage() {
  return (
    <MarketingLayout>
      <SEOPageNew />
    </MarketingLayout>
  );
}
